import React from 'react';

import { useFormikContext } from 'formik';

import Input from 'components/shared/Input/Input';
import Textarea from 'components/shared/Textarea/Textarea';

const TextMacroForm = () => {
  const { values, errors, setFieldValue } = useFormikContext();

  return (
    <div className="flex flex-col gap-y-4">
      <Input
        id="text-macro-input-name"
        label="Text Macro Name"
        data-qa="enter-text-template-label"
        placeholder="Enter text macro name"
        name="name"
        autoComplete="off"
        value={values?.name}
        onChange={(event) => setFieldValue('name', event.target.value)}
        required
        error={errors?.name}
      />
      <Textarea
        id="text-macro-input-name"
        label="Text Macro Content"
        data-qa="enter-text-template-content"
        placeholder="Enter text macro content"
        name="body"
        autoComplete="off"
        value={values?.body}
        onChange={(event) => setFieldValue('body', event.target.value)}
        required
        resizeY
        error={errors?.body}
        textareaClassName="min-h-[200px]"
      />
    </div>
  );
};

export default TextMacroForm;
